import React, { FunctionComponent } from 'react';

import { ProtectedContentWithoutCompletedRequests } from 'app/components/protected-content-without-completed-requests';
import { useBroadbandOfferRequest } from 'app/pages/order/hooks/use-broadband-offer-request';
import { useInitializeShoppingCartRequest } from 'app/pages/order/hooks/use-initialize-shopping-cart-request';
import { usePurchaseEligibilityRequest } from 'app/pages/order/hooks/use-purchase-eligibility-request';

import { HousingSelectPageContent } from './housing-select-page-content';

export const HousingSelectPage: FunctionComponent = () => {
    const broadbandOfferRequest = useBroadbandOfferRequest();
    const initializeShoppingCartRequest = useInitializeShoppingCartRequest();
    const purchaseEligibilityRequest = usePurchaseEligibilityRequest();

    return (
        <ProtectedContentWithoutCompletedRequests requests={[purchaseEligibilityRequest, broadbandOfferRequest]}>
            <ProtectedContentWithoutCompletedRequests requests={[initializeShoppingCartRequest]}>
                <HousingSelectPageContent />
            </ProtectedContentWithoutCompletedRequests>
        </ProtectedContentWithoutCompletedRequests>
    );
};
